<template>
  <div id="myAddress">
    <div class="addressForm">
      <div class="topTitle">我的地址</div>
      <div class="contentInfos" :style="{ height: '332px' }">
        <el-form ref="formData" :model="formData" :rules="rules" label-width="106px" :hide-required-asterisk="true" label-position="right">
          <el-form-item label="收件人姓名:" prop="name">
            <el-input v-model="formData.name" :maxlength="25" style="width: 250px" placeholder="输入收件人姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号码:" prop="tel">
            <el-input v-model="formData.tel" :maxlength="11" style="width: 250px" placeholder="输入收件人手机号码"></el-input>
          </el-form-item>
          <el-form-item label="所在地区:">
            <el-row>
              <el-col style="width: 250px">
                <el-form-item label="" prop="province" class="noBottom">
                  <el-select
                    v-model="formData.province"
                    placeholder="请选择您所在的省份"
                    popper-class="_addressStyle"
                    style="width: 250px"
                    @change="seletekey($event, 'province')"
                  >
                    <el-option v-for="val in proviceList" :key="val" :label="val" :value="val"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col style="width: 250px; margin-left: 12px">
                <el-form-item label="" prop="city" class="noBottom">
                  <el-select
                    v-model="formData.city"
                    placeholder="请选择您所在的城市"
                    popper-class="_addressStyle"
                    style="width: 250px"
                    @change="seletekey($event, 'city')"
                  >
                    <el-option v-for="val in cityList" :key="val" :label="val" :value="val"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col style="width: 250px; margin-left: 12px">
                <el-form-item label="" prop="county" class="noBottom">
                  <el-select
                    v-model="formData.county"
                    placeholder="请选择您所在的区/县"
                    popper-class="_addressStyle"
                    style="width: 250px"
                    @change="seletekey($event, 'area')"
                  >
                    <el-option v-for="val in countyList" :key="val" :label="val" :value="val"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="详细地址:" prop="addressDetail">
            <el-input
              v-model="formData.addressDetail"
              style="width: 774px"
              :maxlength="40"
              placeholder="请输入详细地址精确到门牌号如:XX小区XX单元XX栋XXXX室"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="footerBtn">
          <el-checkbox v-model="formData.isDefault" class="setBtn">设置默认地址</el-checkbox>
          <span class="savebtn" @click="onSubmit('formData')">保存收货地址</span>
        </div>
      </div>
    </div>
    <div v-if="tableData.length" class="addressList">
      <el-table ref="addressList" :data="tableData" style="width: 100%" height="462" border>
        <el-table-column prop="recipients" label="收货人" align="center" width="109"></el-table-column>
        <el-table-column prop="region" label="所在地区" align="center" width="200">
          <template slot-scope="scope">
            <span style="color: #333333">{{ JSON.parse(scope.row.region).region[0].split('/').join(' ') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="addressName" label="详细地址" align="center" width="223">
          <template slot-scope="scope">
            <span style="color: #333333">{{ JSON.parse(scope.row.region).address }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="recipientsCellphone" label="电话手机" align="center" width="156"></el-table-column>
        <el-table-column label="操作" align="center" width="142">
          <template slot-scope="scope">
            <span style="color: #333333; cursor: pointer" @click="editList(scope.row)">修改</span>
            <div v-if="scope.row.defaultFlag === 0" class="line"></div>
            <span v-if="scope.row.defaultFlag === 0" style="color: #333333; cursor: pointer" @click="deleteAddress(scope.row.addressId)">删除</span>
          </template>
        </el-table-column>
        <el-table-column label="默认" align="center" width="131">
          <template slot-scope="scope">
            <div v-if="scope.row.defaultFlag === 1" class="defaultAddress">默认地址</div>
            <div v-if="scope.row.defaultFlag === 0" class="setdefault" @click="changDefault(scope.row)">设为默认</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="footerPagination">
        <div class="sizeSelect">
          每页
          <el-select v-model="size" placeholder="" @change="handleSizeChange">
            <el-option :label="10" :value="10"></el-option>
            <el-option :label="50" :value="50"></el-option>
            <el-option :label="100" :value="100"></el-option>
            <el-option :label="200" :value="200"></el-option>
          </el-select>
          条
        </div>
        <el-pagination :current-page.sync="page" :page-size="size" layout="prev, pager, next" :total="total" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
    <addressPop ref="addressDia" @complate="complateAddress" />
  </div>
</template>

<script>
/*global BaseApi */
import addressPop from '@/components/address/addressPop.vue'
import areaList from '@/components/address/area.min.js'
export default {
  components: {
    addressPop
  },
  props: {
    isDetail: {
      require: false,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      areaList,
      formData: {
        id: null,
        name: null,
        tel: null,
        area: null,
        addressDetail: null,
        postalCode: null,
        areaCode: null,
        isDefault: false,
        county: null,
        city: null,
        province: null
      },
      page: 1,
      size: 10,
      total: '0',
      tableData: [],
      rules: {
        name: [{ message: '请输入收件人姓名', trigger: 'blur', required: true }],
        tel: [
          { message: '请输入收件人手机号', trigger: 'blur', required: true },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur', required: true }
        ],
        province: [{ message: '请选中您所在的省份', trigger: 'change', required: true }],
        county: [{ message: '请选择您所在的区/县', trigger: 'change', required: true }],
        city: [{ message: '请选择您所在的城市', trigger: 'change', required: true }],
        addressDetail: [{ message: '请输入详细地址', trigger: 'blur', required: true }]
      },
      proviceList: areaList.province_list, //  获取所有的省
      cityList: {},
      countyList: {},
      paramInfo: {},
      submitVisible: false,
      allAddressData: [] // 所有地址
    }
  },
  mounted() {
    this.queryFirmAddress()
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.page = 1
      this.tableData = this.allAddressData.slice((this.page - 1) * this.size, this.size * this.page)
      this.$nextTick(() => {
        document.getElementsByClassName('el-table__body-wrapper')[0].scrollTop = 0
      })
      // this.queryFirmAddress()
    },
    handleCurrentChange(val) {
      this.page = val
      this.tableData = this.allAddressData.slice((this.page - 1) * this.size, this.size * this.page)
      this.$nextTick(() => {
        document.getElementsByClassName('el-table__body-wrapper')[0].scrollTop = 0
      })
      // this.queryFirmAddress()
    },
    complateAddress() {
      this.page = 1
      this.queryFirmAddress()
    },
    editList(row) {
      const params = {
        isAdd: 'modify',
        modifyId: row.addressId
      }
      this.$refs.addressDia.openDialog(params)
    },
    firstCityCountry() {
      // 修改地址时第一次赋值cityList,countyList
      this.cityList = {}
      this.countyList = {}
      Object.keys(this.proviceList).filter((item) => {
        if (this.proviceList[item] === this.formData.city) {
          Object.keys(this.areaList.city_list).filter((cityItem) => {
            if (String(cityItem).slice(0, 2) === String(item).slice(0, 2)) {
              this.cityList[cityItem] = this.areaList.city_list[cityItem]
            }
          })
        }
      })
      Object.keys(this.areaList.county_list).filter((cityItem) => {
        if (String(cityItem).slice(0, 4) === String(this.formData.areaCode).slice(0, 4)) {
          this.countyList[cityItem] = this.areaList.county_list[cityItem]
        }
      })
    },
    seletekey(e, type) {
      if (e) {
        switch (type) {
          case 'province':
            this.cityList = {}
            this.countyList = {}
            this.formData.city = null
            this.formData.county = null
            Object.keys(this.proviceList).filter((item) => {
              if (this.proviceList[item] === e) {
                Object.keys(this.areaList.city_list).filter((cityItem) => {
                  if (String(cityItem).slice(0, 2) === String(item).slice(0, 2)) {
                    this.cityList[cityItem] = this.areaList.city_list[cityItem]
                  }
                })
              }
            })
            break
          case 'city':
            this.countyList = {}
            this.formData.county = null
            Object.keys(this.cityList).filter((item) => {
              if (this.cityList[item] === e) {
                Object.keys(this.areaList.county_list).filter((cityItem) => {
                  if (String(cityItem).slice(0, 4) === String(item).slice(0, 4)) {
                    this.countyList[cityItem] = this.areaList.county_list[cityItem]
                  }
                })
              }
            })
            break
          case 'area':
            this.$forceUpdate()
            this.formData.area = this.formData.province + '/' + this.formData.city + '/' + this.formData.county + ''
            Object.keys(this.countyList).filter((item) => {
              if (this.countyList[item] === e) {
                this.formData.areaCode = item
              }
            })
            break
        }
      }
    },
    // 获取收货地址
    queryFirmAddress() {
      var that = this
      BaseApi.getUserAddress({}).then((response) => {
        // eslint-disable-next-line no-unused-vars
        const { value, message, code } = response.data
        that.isAddressLoading = false
        if (Number(code) === 0) {
          if (value.length !== 0) {
            this.allAddressData = value
            this.tableData = value.slice(0, this.size)
            this.total = value.length
            // for (let i = 0; i < value.length; i++) {
            //   const item = value[i]
            //   item.name = item.recipients
            //   item.tel = item.recipientsCellphone
            //   item.isDefault = item.defaultFlag
            //   item.address = item.addressName
            //   item.id = item.addressId
            //   that.tableData.push(item)
            //   // 进入地址是选择的是第二页的判断
            //   if (item.id == that.chooseId) {
            //     that.startIndex = Math.floor(i / 3) * 3
            //     that.endIndex = Math.floor(that.startIndex + 3)
            //   }
            //   if (item.defaultFlag) {
            //     sessionStorage.setItem('defaultAddress', JSON.stringify(item))
            //   }
            // }
          } else {
            that.isShowNoData = true
          }
        } else {
          // eslint-disable-next-line no-undef
          this.$message(message)
        }
      })
    },
    getAddressDetails() {
      const that = this
      const addressDetailId = this.paramInfo.modifyId
      if (addressDetailId) {
        BaseApi.getUserAddressWithId(addressDetailId).then((response) => {
          const { value, message, code } = response.data
          // eslint-disable-next-line eqeqeq
          if (code == 0) {
            if (value.length !== 0) {
              const currentaddressDetail = value[0]
              that.formData.name = currentaddressDetail.recipients
              that.formData.tel = currentaddressDetail.recipientsCellphone
              that.formData.postalCode = currentaddressDetail.postCode
              that.formData.id = currentaddressDetail.addressDetailId
              if (currentaddressDetail.region) {
                that.formData.addressDetail = JSON.parse(currentaddressDetail.region).address
                const region = value[0]['region']
                const jsReg = JSON.parse(region)['region']
                that.formData.area = jsReg[0]
                that.formData.areaCode = JSON.parse(currentaddressDetail.region).areaCode
                const areaList = that.formData.area.split('/')
                that.formData.province = areaList[0]
                that.formData.city = areaList[1]
                that.formData.county = areaList[2]
                that.firstCityCountry()
              }
              if (currentaddressDetail.defaultFlag === 1) {
                that.formData.isDefault = true
              } else {
                that.formData.isDefault = false
              }
            }
          } else {
            this.$message(message)
          }
        })
      }
    },
    onSubmit(formName) {
      // {"addressName":"北京市,北京市,朝阳区测试Pc地址","defaultFlag":0,"recipients":"测试传参","recipientsCellphone":"13389095763","region":"{\"region\":[\"北京市/北京市/朝阳区\"],\"address\":\"测试Pc地址\",\"areaCode\":\"110105\"}"}
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.submitVisible) {
            return
          }
          this.submitVisible = true
          const that = this
          // const addressDetailId = this.paramInfo.modifyId
          // const saveType = this.paramInfo.isAdd
          const peisong = this.formData.area.replace(/(\/)/g, ',') + this.formData.addressDetail
          // '{'region':['河北省','石家庄市','长安区'],'addressDetail':'dasf'}'
          const selectedCity = this.formData.area.split(',')
          const region = { region: selectedCity, address: this.formData.addressDetail, areaCode: this.formData.areaCode }
          const sendValue = {
            addressName: peisong, // 收货地址
            defaultFlag: this.formData.isDefault === true ? 1 : 0, // 是否设置为默认收获地址 (0:否 1:是)
            postCode: this.formData.postalCode, // 邮政编码
            recipients: this.formData.name, // 收货人
            recipientsCellphone: this.formData.tel, //	收货人电话
            region: JSON.stringify(region) // 地区(前端维护辅助字段)
          }
          BaseApi.saveUserAddress(sendValue).then((response) => {
            const { code, message } = response.data
            // eslint-disable-next-line eqeqeq
            if (code == 0) {
              this.$message(message)
              that.$refs['formData'].resetFields()
              this.formData = {
                id: null,
                name: null,
                tel: null,
                area: null,
                addressDetail: null,
                postalCode: null,
                areaCode: null,
                isDefault: false,
                county: null,
                city: null,
                province: null
              }
              // if (this.isDetail) {
              //   // 商品详情页新增地址弹框
              //   that.$emit('complate')
              // } else {
              // }
              this.complateAddress()
              this.submitVisible = false
            } else {
              this.$message(message)
              this.submitVisible = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    changDefault(item) {
      // 改变是否默认地址
      // if (item.isDefault === true) {
      const sendValue = {
        addressId: item.addressId,
        addressName: item.address, // 收货地址
        defaultFlag: 1, // 是否设置为默认收获地址 (0:否 1:是)
        postCode: item.postCode, // 邮政编码
        recipients: item.name, // 收货人
        recipientsCellphone: item.tel, //	收货人电话
        region: item.region // 地区(前端维护辅助字段)
      }
      const that = this
      BaseApi.updateUserAddress(sendValue).then((response) => {
        const { code, message } = response.data
        this.$message(message)
        if (code === 0 || code === '0') {
          that.tableData.forEach((ele) => {
            // eslint-disable-next-line eqeqeq
            if (ele.addressId == item.addressId) {
              sessionStorage.setItem('defaultAddress', JSON.stringify(ele))
            } else {
              ele.isDefault = 0
            }
          })
          // this.tableData = []
          that.complateAddress()
        }
      })
      // } else {
      //   item.isDefault = 1
      //   this.$message('必须有一个默认地址')
      // }
    },
    deleteAddress(id) {
      const that = this
      const addressId = {
        addressId: id
      }
      BaseApi.deleteUserAddress(addressId).then((response) => {
        const { code, message } = response.data
        // eslint-disable-next-line eqeqeq
        if (code == 0) {
          this.$message(message)
          // this.tableData = []
          that.complateAddress()
        } else {
          this.$message(message)
        }
      })
    }
  }
}
</script>
<style lang="scss">
#myAddress .el-table td div {
  text-align: center;
  font-size: 14px;
  color: #fff;
}
</style>
<style lang="scss" scoped>
#myAddress {
  .addressForm {
    background: #fff;
    border-radius: 8px;
    .topTitle {
      height: 35px;
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
    }
    .contentInfos {
      padding: 40px 0;
      position: relative;
      /deep/.el-input__inner::placeholder {
        color: #a1a1a1;
      }
      /deep/.el-form-item__label {
        padding-right: 20px;
        color: #333333;
      }
      /deep/.el-input__inner {
        padding: 7px 0px 7px 20px;
        background: transparent;
        border: 1px solid #c3c6ce;
        color: #333333;
      }
      .footerBtn {
        position: absolute;
        left: 20px;
        bottom: 40px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        /deep/ .el-checkbox__inner {
          width: 20px;
          height: 20px;
          border-radius: 4px;
        }
        /deep/ .el-checkbox__label {
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
        }
        /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
          background: #1571db;
          border-color: #1571db;
          color: #fff;
        }
        /deep/ .el-checkbox__inner::after {
          border: 2px solid #ffffff;
          border-left: 0;
          border-top: 0;
          width: 4px;
          height: 9px;
          left: 6px;
          top: 2px;
        }
        .setBtn {
          margin-right: 20px;
          color: #fefffe;
          font-size: 14px;
        }
        .savebtn {
          cursor: pointer;
          display: inline-block;
          width: 148px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: #1571db;
          border-radius: 4px 4px 4px 4px;
          font-size: 18px;
          font-family: PingFang HK-Medium, PingFang HK;
          font-weight: 500;
          color: #fff;
        }
      }
    }
  }
  .addressList {
    margin-top: 20px;
    width: 960px;
    height: 662px;
    // background: #ffffff;
    border-radius: 8px;
    .footerPagination {
      display: flex;
      justify-content: center;
      /* 侧轴居中 */
      align-items: center;
      padding: 20px 0;
      .sizeSelect {
        color: #606266;
        font-size: 14px;
        margin-right: 30px;
        /deep/.el-input__inner {
          width: 60px;
          height: 28px;
          border-radius: 3px;
          padding-left: 10px;
          padding-right: 20px;
          background: transparent;
        }
        /deep/ .el-input__suffix {
          height: 38px;
          top: -5px;
        }
      }
      .el-pagination {
        display: inline-block;
        /deep/ .btn-prev {
          background: transparent;
        }
        /deep/ .btn-next {
          background: transparent;
        }
        /deep/ .number {
          background: transparent;
        }
      }
    }
    .el-table {
      border: 0;
      border-radius: 8px;
      /deep/.el-table--border::after {
        width: 0;
      }
      .line {
        display: inline-block;
        margin: 0 14px;
        width: 0px;
        height: 12px;
        border: 1px solid #ffffff;
      }
      .defaultAddress {
        margin: 0 auto;
        width: 80px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #1571db;
        border-radius: 4px;
        color: #ffffff;
      }
      .setdefault {
        cursor: pointer;
        color: #333333;
      }
    }
    /deep/.el-table--scrollable-x .el-table__body-wrapper{
      overflow-x: hidden;
    }
    /deep/.el-table th.el-table__cell {
      background: #f4f4f4;
      height: 40px;
    }
    /deep/.el-table {
      background: #ffffff;
    }
    /deep/.el-table table tr {
      background: transparent;
    }
    /deep/ .cell {
      font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
      font-weight: 500;
      color: #333333;
    }
    /deep/.el-table__header-wrapper .cell {
      font-size: 20px;
    }
    /deep/ .el-table th.el-table__cell.is-leaf {
      border-bottom: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
    }
  }
  .el-table--border {
    &:after {
      width: 0;
    }
  }
}
</style>
